<div class="card shadow-lg">
    <div class="text-center">
        <h3>Velkommen til ekstern.Crono .. logger ind...</h3>
    </div>
</div>
